import React from "react";
import { Spin } from "antd";

const Loader = (props) => {
  console.log("asc loader props", props);

  const contentStyle = {
    padding: "25px 85px",
    background: "rgba(0, 0, 0, 0.05)",
    borderRadius: 4,
    inset: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
    ...props.style,
  };

  const content = <div style={contentStyle} />;

  return (
    <div>
      {/* <style>
        {`
          .custom-spin .ant-spin-dot i {
            background-color: red !important;
          }
        `}
      </style> */}

      {/* <Spin size="small" /> */}

      {/* <Spin description="Loading" size="small" className="d-none">
        {content}
      </Spin> */}

      <Spin
        description={props.description}
        size={props.size}
        // className="custom-spin" // to change spin color.
        className={props.className}
        styles={props.styles}
      >
        {content}
      </Spin>
    </div>
  );
};

export default Loader;
